import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107050Status: 'idle',
    startProcess107050Error: undefined as any,
    loadUserParamsProcess107050Status: 'idle',
    loadUserParamsProcess107050Error: undefined as any,

    process107050List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107050 = createAsyncThunk('process107050Slice/startProcess107050', async ({ process107050 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107050/`,
        prepareData(process107050),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107050Status } = getState().process107050Slice
        return startProcess107050Status !== 'pending'
    }
})

export const loadUserParamsProcess107050 = createAsyncThunk('process107050Slice/loadUserParamsProcess107050', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107050/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107050Status } = getState().process107050Slice
        return loadUserParamsProcess107050Status !== 'pending'
    }
})

const Process107050Slice = createSlice({
    name: 'process107050Slice',
    initialState,
    reducers: {
        resetstartProcess107050: (state) => {
            state.job = undefined
            state.startProcess107050Error = undefined
        },
        resetstartProcess107050Error: (state) => {
            state.startProcess107050Error = undefined
        },
        resetloadUserParamsProcess107050: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107050Error = undefined
        },
        resetloadUserParamsProcess107050Error: (state) => {
            state.loadUserParamsProcess107050Error = undefined
        },
        removeFromProcess107050ListById: (state, action) => {
            state.process107050List = state.process107050List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107050ListByIds: (state, action) => {
            state.process107050List = state.process107050List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107050List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107050Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107050List = []
            state.startProcess107050Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107050.pending, (state) => {
            state.startProcess107050Status = 'pending'
            state.startProcess107050Error = undefined
        })
        builder.addCase(startProcess107050.fulfilled, (state, action) => {
            state.startProcess107050Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107050.rejected, (state, action) => {
            state.startProcess107050Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107050Error = action.error.message
            } else {
                state.startProcess107050Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107050.pending, (state) => {
            state.loadUserParamsProcess107050Status = 'pending'
            state.loadUserParamsProcess107050Error = undefined
        })
        builder.addCase(loadUserParamsProcess107050.fulfilled, (state, action) => {
            state.loadUserParamsProcess107050Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107050.rejected, (state, action) => {
            state.loadUserParamsProcess107050Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107050Error = action.error.message
            } else {
                state.loadUserParamsProcess107050Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107050,
    resetstartProcess107050Error,
    resetloadUserParamsProcess107050,
    resetloadUserParamsProcess107050Error,
    removeFromProcess107050ListById,
    removeFromProcess107050ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107050Slice.actions
export default Process107050Slice.reducer
